// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nkl-popover {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: 'tnum';
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1030;
  max-width: 100vw;
  font-weight: normal;
  white-space: normal;
  text-align: left;
  cursor: auto;
  user-select: text;
}
.nkl-popover-content {
  position: relative;
}
.nkl-popover::after {
  position: absolute;
  background: rgba(255, 255, 255, 0.01);
  content: '';
}
.nkl-popover-hidden {
  display: none;
}
.nkl-popover-placement-top,
.nkl-popover-placement-topLeft,
.nkl-popover-placement-topRight {
  padding-bottom: 15.3137085px;
}
.nkl-popover-placement-right,
.nkl-popover-placement-rightTop,
.nkl-popover-placement-rightBottom {
  padding-left: 15.3137085px;
}
.nkl-popover-placement-bottom,
.nkl-popover-placement-bottomLeft,
.nkl-popover-placement-bottomRight {
  padding-top: 15.3137085px;
}
.nkl-popover-placement-left,
.nkl-popover-placement-leftTop,
.nkl-popover-placement-leftBottom {
  padding-right: 15.3137085px;
}
.nkl-popover-inner {
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 2px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .nkl-popover {
    /* IE10+ */
  }
  .nkl-popover-inner {
    box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  }
}
.nkl-popover-title {
  min-width: 177px;
  min-height: 32px;
  margin: 0;
  padding: 5px 16px 4px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  border-bottom: 1px solid #f0f0f0;
}
.nkl-popover-inner-content {
  width: max-content;
  max-width: 100%;
  padding: 12px 16px;
  color: rgba(0, 0, 0, 0.85);
}
.nkl-popover-message {
  display: flex;
  padding: 4px 0 12px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
}
.nkl-popover-message-icon {
  display: inline-block;
  margin-right: 8px;
  color: #faad14;
  font-size: 14px;
}
.nkl-popover-buttons {
  margin-bottom: 4px;
  text-align: right;
}
.nkl-popover-buttons button:not(:first-child) {
  margin-left: 8px;
}
.nkl-popover-arrow {
  position: absolute;
  display: block;
  width: 22px;
  height: 22px;
  overflow: hidden;
  background: transparent;
  pointer-events: none;
}
.nkl-popover-arrow-content {
  --antd-arrow-background-color: #fff;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  width: 11.3137085px;
  height: 11.3137085px;
  margin: auto;
  content: '';
  pointer-events: auto;
  border-radius: 0 0 2px;
  pointer-events: none;
}
.nkl-popover-arrow-content::before {
  position: absolute;
  top: -11.3137085px;
  left: -11.3137085px;
  width: 33.9411255px;
  height: 33.9411255px;
  background: var(--antd-arrow-background-color);
  background-repeat: no-repeat;
  background-position: -10px -10px;
  content: '';
  clip-path: inset(33% 33%);
  clip-path: path('M 9.849242404917499 24.091883092036785 A 5 5 0 0 1 13.384776310850237 22.627416997969522 L 20.627416997969522 22.627416997969522 A 2 2 0 0 0 22.627416997969522 20.627416997969522 L 22.627416997969522 13.384776310850237 A 5 5 0 0 1 24.091883092036785 9.849242404917499 L 23.091883092036785 9.849242404917499 L 9.849242404917499 23.091883092036785 Z');
}
.nkl-popover-placement-top .nkl-popover-arrow,
.nkl-popover-placement-topLeft .nkl-popover-arrow,
.nkl-popover-placement-topRight .nkl-popover-arrow {
  bottom: 0;
  transform: translateY(100%);
}
.nkl-popover-placement-top .nkl-popover-arrow-content,
.nkl-popover-placement-topLeft .nkl-popover-arrow-content,
.nkl-popover-placement-topRight .nkl-popover-arrow-content {
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);
  transform: translateY(-11px) rotate(45deg);
}
.nkl-popover-placement-top .nkl-popover-arrow {
  left: 50%;
  transform: translateY(100%) translateX(-50%);
}
.nkl-popover-placement-topLeft .nkl-popover-arrow {
  left: 16px;
}
.nkl-popover-placement-topRight .nkl-popover-arrow {
  right: 16px;
}
.nkl-popover-placement-right .nkl-popover-arrow,
.nkl-popover-placement-rightTop .nkl-popover-arrow,
.nkl-popover-placement-rightBottom .nkl-popover-arrow {
  left: 0;
  transform: translateX(-100%);
}
.nkl-popover-placement-right .nkl-popover-arrow-content,
.nkl-popover-placement-rightTop .nkl-popover-arrow-content,
.nkl-popover-placement-rightBottom .nkl-popover-arrow-content {
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);
  transform: translateX(11px) rotate(135deg);
}
.nkl-popover-placement-right .nkl-popover-arrow {
  top: 50%;
  transform: translateX(-100%) translateY(-50%);
}
.nkl-popover-placement-rightTop .nkl-popover-arrow {
  top: 12px;
}
.nkl-popover-placement-rightBottom .nkl-popover-arrow {
  bottom: 12px;
}
.nkl-popover-placement-bottom .nkl-popover-arrow,
.nkl-popover-placement-bottomLeft .nkl-popover-arrow,
.nkl-popover-placement-bottomRight .nkl-popover-arrow {
  top: 0;
  transform: translateY(-100%);
}
.nkl-popover-placement-bottom .nkl-popover-arrow-content,
.nkl-popover-placement-bottomLeft .nkl-popover-arrow-content,
.nkl-popover-placement-bottomRight .nkl-popover-arrow-content {
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.06);
  transform: translateY(11px) rotate(-135deg);
}
.nkl-popover-placement-bottom .nkl-popover-arrow {
  left: 50%;
  transform: translateY(-100%) translateX(-50%);
}
.nkl-popover-placement-bottomLeft .nkl-popover-arrow {
  left: 16px;
}
.nkl-popover-placement-bottomRight .nkl-popover-arrow {
  right: 16px;
}
.nkl-popover-placement-left .nkl-popover-arrow,
.nkl-popover-placement-leftTop .nkl-popover-arrow,
.nkl-popover-placement-leftBottom .nkl-popover-arrow {
  right: 0;
  transform: translateX(100%);
}
.nkl-popover-placement-left .nkl-popover-arrow-content,
.nkl-popover-placement-leftTop .nkl-popover-arrow-content,
.nkl-popover-placement-leftBottom .nkl-popover-arrow-content {
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);
  transform: translateX(-11px) rotate(-45deg);
}
.nkl-popover-placement-left .nkl-popover-arrow {
  top: 50%;
  transform: translateX(100%) translateY(-50%);
}
.nkl-popover-placement-leftTop .nkl-popover-arrow {
  top: 12px;
}
.nkl-popover-placement-leftBottom .nkl-popover-arrow {
  bottom: 12px;
}
.nkl-popover-pink .nkl-popover-inner {
  background-color: #eb2f96;
}
.nkl-popover-pink .nkl-popover-arrow-content {
  background-color: #eb2f96;
}
.nkl-popover-magenta .nkl-popover-inner {
  background-color: #eb2f96;
}
.nkl-popover-magenta .nkl-popover-arrow-content {
  background-color: #eb2f96;
}
.nkl-popover-red .nkl-popover-inner {
  background-color: #f5222d;
}
.nkl-popover-red .nkl-popover-arrow-content {
  background-color: #f5222d;
}
.nkl-popover-volcano .nkl-popover-inner {
  background-color: #fa541c;
}
.nkl-popover-volcano .nkl-popover-arrow-content {
  background-color: #fa541c;
}
.nkl-popover-orange .nkl-popover-inner {
  background-color: #fa8c16;
}
.nkl-popover-orange .nkl-popover-arrow-content {
  background-color: #fa8c16;
}
.nkl-popover-yellow .nkl-popover-inner {
  background-color: #fadb14;
}
.nkl-popover-yellow .nkl-popover-arrow-content {
  background-color: #fadb14;
}
.nkl-popover-gold .nkl-popover-inner {
  background-color: #faad14;
}
.nkl-popover-gold .nkl-popover-arrow-content {
  background-color: #faad14;
}
.nkl-popover-cyan .nkl-popover-inner {
  background-color: #13c2c2;
}
.nkl-popover-cyan .nkl-popover-arrow-content {
  background-color: #13c2c2;
}
.nkl-popover-lime .nkl-popover-inner {
  background-color: #a0d911;
}
.nkl-popover-lime .nkl-popover-arrow-content {
  background-color: #a0d911;
}
.nkl-popover-green .nkl-popover-inner {
  background-color: #52c41a;
}
.nkl-popover-green .nkl-popover-arrow-content {
  background-color: #52c41a;
}
.nkl-popover-blue .nkl-popover-inner {
  background-color: #1890ff;
}
.nkl-popover-blue .nkl-popover-arrow-content {
  background-color: #1890ff;
}
.nkl-popover-geekblue .nkl-popover-inner {
  background-color: #2f54eb;
}
.nkl-popover-geekblue .nkl-popover-arrow-content {
  background-color: #2f54eb;
}
.nkl-popover-purple .nkl-popover-inner {
  background-color: #722ed1;
}
.nkl-popover-purple .nkl-popover-arrow-content {
  background-color: #722ed1;
}
.nkl-popover-rtl {
  direction: rtl;
  text-align: right;
}
.nkl-popover-rtl .nkl-popover-message-icon {
  margin-right: 0;
  margin-left: 8px;
}
.nkl-popover-rtl .nkl-popover-message-title {
  padding-left: 16px;
}
.nkl-popover-rtl .nkl-popover-buttons {
  text-align: left;
}
.nkl-popover-rtl .nkl-popover-buttons button {
  margin-right: 8px;
  margin-left: 0;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
